"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.on = void 0;
var constants_1 = require("../_constants");
var on = function (eventType, callback) {
    window.addEventListener('message', function (event) {
        // We only accept messages from ourselves
        if (event.origin !== window.origin)
            return;
        if (event.source !== window && event.data.app === constants_1.GEM_WALLET)
            return;
        if (!event.data.source || event.data.source !== 'GEM_WALLET_MSG_REQUEST')
            return;
        if (event.data.type && event.data.type === eventType) {
            callback(event.data.payload.result);
        }
    });
};
exports.on = on;
